import http from '@/core/http/index';
import type { ICategoryListReq, ICategoryListItem } from './types';

/**
 *  (商品库)类目 - 商品类目
 * 接口来源履约
 */
export const getCategoryList = (productType: ICategoryListReq) => {
  const url = `/product/web/v1/category/list/${productType}`;
  return http.get<ICategoryListItem[]>({
    url,
  });
};
